import React, { ReactElement, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { RiCalendarScheduleLine } from "@remixicon/react";
import { TicketItem } from "../../../contexts/ticket-state";
import Scheduler from "../../scheduler/Scheduler";

interface RescheduleMessageActionProps {
    date: Date;
    iconOnly?: boolean;
    ticketMessageId: string;
    ticketItem?: TicketItem;
}

export default function RescheduleMessageAction({
    date, iconOnly, ticketMessageId, ticketItem,
}: RescheduleMessageActionProps): ReactElement {
    const [shouldShow, setShow] = useState(false);

    const onSave = (newDate: Date) => {
        ticketItem?.rescheduleMessage(ticketMessageId, newDate);
    };

    return (
        <>
            <Scheduler
                date={date}
                shouldShow={shouldShow}
                onCancel={() => setShow(false)}
                title="Reschedule the Reply"
                onSelected={newDate => {
                    setShow(false);
                    onSave(newDate);
                }}
            />

            <Dropdown.Item onClick={() => setShow(true)} title={iconOnly ? "Reschedule" : undefined}>
                {iconOnly ? <RiCalendarScheduleLine /> : "Reschedule"}
            </Dropdown.Item>
        </>
    );
}

RescheduleMessageAction.defaultProps = {
    iconOnly: false,
    ticketItem: undefined,
};
